import type { FC } from "react";
import type {
  MatchLineup as XpaMatchLineup,
  TeamLineup,
} from "@motain/xpa-proto-files-web/lib/types/match_lineup";
import { isNullable } from "@/types/isNullable";
import { useState } from "react";
import { ToggleButton } from "@/components/toggel-button/ToggleButton";
import { MatchLineupFlat } from "../match-lineup-flat/MatchLineupFlat";
import { MatchLineupFormation } from "../match-lineup-formation/MatchLineupFormation";
import styles from "./MatchLineup.module.scss";

export const MatchLineup: FC<XpaMatchLineup> = (props) => {
  const { homeTeam, awayTeam } = props;
  const [activeTeam, setActiveTeam] = useState<TeamLineup | undefined>(
    homeTeam,
  );

  if (isNullable(homeTeam) || isNullable(awayTeam)) {
    return null;
  }

  const teams = [homeTeam, awayTeam];

  return (
    <>
      <nav aria-label={`${homeTeam.teamName} - ${awayTeam.teamName}`}>
        <ul className={styles.selectors}>
          {teams.map((team) => {
            return (
              <li key={team.teamName}>
                <ToggleButton
                  onClick={() => {
                    setActiveTeam(team);
                  }}
                  isActive={team === activeTeam}
                  className={styles.selectorButton}
                >
                  <span className={styles.selectorName}>{team.teamName}</span>
                </ToggleButton>
              </li>
            );
          })}
        </ul>
      </nav>

      {activeTeam?.variant?.$case === "formation" && (
        <MatchLineupFormation
          {...activeTeam.variant.formation}
        ></MatchLineupFormation>
      )}
      {activeTeam?.variant?.$case === "flat" && (
        <MatchLineupFlat {...activeTeam.variant.flat}></MatchLineupFlat>
      )}
    </>
  );
};
